import { Analytics } from './service';
let analytics = null;
let sessionInfo = null;
export const init = (config) => {
    // Clean up existing instance
    if (analytics) {
        analytics.destroy();
    }
    analytics = new Analytics({
        appId: config.appId,
        isProd: config.isProd,
    });
};
/**
 * Clean up and destroy the analytics instance
 */
export const destroy = () => {
    if (analytics) {
        analytics.destroy();
        analytics = null;
    }
    sessionInfo = null;
};
export const track = (event, timestamp = Date.now()) => {
    if (!analytics || !sessionInfo) {
        return;
    }
    analytics.markEvent({
        ...event,
        ...sessionInfo,
    }, timestamp);
};
export const startSession = (_sessionInfo) => {
    sessionInfo = _sessionInfo;
};
export const endSession = () => {
    sessionInfo = null;
};
